module.exports = __webpack_public_path__ + "assets/images/2ad460a440c8e1fc5152ed13e2d05621-satellite.png";